import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[dataE2e]',
    standalone: false
})
export class E2eTestIdDirective implements OnInit {

    @Input() e2eTestId: string;

    @Input() dataE2eType: string;

    constructor(private el: ElementRef,
                private renderer: Renderer2) {
    }

    ngOnInit(): void {
        if (this.e2eTestId) {
            const shortCut = this.dataE2eType ? `${this.dataE2eType}-` : '';
            this.renderer.setAttribute(this.el.nativeElement, 'data-test', shortCut + this.e2eTestId);
        }
    }
}
